import { useEffect, useState } from "react";
import { AlertCircle, Loader2 } from "lucide-react";
import { setAdminImpersonationToken } from "@/lib/adminToken";

export default function AdminImpersonationEntry() {
  const [error, setError] = useState("");

  useEffect(() => {
    const token = decodeURIComponent(window.location.hash.slice(1));
    window.history.replaceState(null, "", window.location.pathname);

    if (!token) {
      setError("This account-view link is missing its temporary sign-in token.");
      return;
    }

    const validate = async () => {
      try {
        const response = await fetch("/api/admin/auth", {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();
        if (!response.ok || !data.user) {
          setError(data.error || "This temporary account-view session has expired.");
          return;
        }

        setAdminImpersonationToken(token);
        window.location.replace("/admin");
      } catch {
        setError("Could not validate the temporary account-view session.");
      }
    };

    void validate();
  }, []);

  return (
    <main className="min-h-screen flex items-center justify-center bg-neutral-50 p-6">
      <div className="max-w-sm text-center">
        {error ? (
          <>
            <AlertCircle className="w-8 h-8 text-red-500 mx-auto mb-3" />
            <p className="text-sm text-neutral-600">{error}</p>
            <a href="/admin" className="inline-block mt-4 text-sm text-accent hover:underline">Return to admin</a>
          </>
        ) : (
          <>
            <Loader2 className="w-8 h-8 text-accent animate-spin mx-auto mb-3" />
            <p className="text-sm text-neutral-600">Opening the user account…</p>
          </>
        )}
      </div>
    </main>
  );
}
